"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// helper to capitalize strings

exports.default = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/inline-style-prefixer/lib/utils/capitalizeString.js
// module id = 322
// module chunks = 6